import { create } from "zustand";

export const useBase = create((set) => ({
  // event Id layout data
  eventId: null,
  setEventId: (data) => set({ eventId: data }),

  // slug
  siteSlug: null,
  setSiteSlug: (data) => set({ siteSlug: data }),

  //user token
  userToken: null,
  setUserToken: (data) => set({ userToken: data }),
}));
